import { M8ProdStackDTO } from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

type Params = {
  idUser: number;
};

export const getUserProdStack = async (
  params: Params
): Promise<null | M8ProdStackDTO> => {
  const response = await customFetch(
    getM8AdminURL(`getUserProdStack?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return null;
};
